// extracted by mini-css-extract-plugin
export default {"card":"sba-z","carousel":"tba-z"};